// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiConfig } from "../../apiConfig";
import { getHeaders, ApiScope } from "../silentAuth";
import { CreateResourceGroupCommand } from "./types";
import { IResourceGroup } from "@oqdo/automationapps/Memberships/ResourceGroup";
import { PagedResult } from "../types";

// Define a service using a base URL and expected endpoints
export const resourceGroupApi = createApi({
  reducerPath: "resourceGroupApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.resourceGroupApiUrl,
    prepareHeaders: async (headers, { getState }) => {
      return await getHeaders(ApiScope, headers);
    },
  }),
  tagTypes: ["ResourceGroups", "BACnetDevices", "AHUOptimizers"],
  endpoints: (builder) => ({
    getResourceGroupById: builder.query<IResourceGroup, string>({
      query: (id) => `/resourcegroups/${id}`,
      providesTags: ["ResourceGroups"],
    }),
    getResourceGroupBacnetDevices: builder.query<any[], string>({
      query: (id) => `/resourcegroups/${id}/bacnetdevices`,
      providesTags: ["BACnetDevices"],
    }),
    getResourceGroupAHUOptimizers: builder.query<any[], string>({
      query: (id) => `/resourcegroups/${id}/ahu_optimizers`,
      providesTags: ["AHUOptimizers"],
    }),
    getResourceGroups: builder.query<
      PagedResult<IResourceGroup>,
      { subscriptionId: string | undefined; page: number | undefined; pageSize: number | undefined }
    >({
      query: ({ subscriptionId, page, pageSize }) => {
        return subscriptionId !== undefined
          ? `/resourcegroups?subscription=${subscriptionId}&page=${page ?? 0}&pageSize=${pageSize ?? 100}`
          : `/resourcegroups?page=${page ?? 0}&pageSize=${pageSize ?? 100}`;
      },
      providesTags: ["ResourceGroups"],
    }),
    createResourceGroup: builder.mutation<any, CreateResourceGroupCommand>({
      query: (obj) => ({
        url: `/resourcegroups`,
        method: "post",
        body: obj,
        responseHandler: (response: { text: () => any }) => response.text(),
      }),
      invalidatesTags: ["ResourceGroups"],
    }),
    deleteResourceGroup: builder.mutation<void, string>({
      query: (id) => ({
        url: `/resourcegroups/` + id,
        method: "delete",
      }),
      invalidatesTags: ["ResourceGroups"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetResourceGroupByIdQuery,
  useGetResourceGroupsQuery,
  useCreateResourceGroupMutation,
  useDeleteResourceGroupMutation,
  useGetResourceGroupAHUOptimizersQuery,
  useGetResourceGroupBacnetDevicesQuery,
} = resourceGroupApi;
